import { Component, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { A2ReminderDetailComponent } from "./a2-reminder-detail/a2-reminder-detail.component";
import { A2GiftInventoryComponent } from "./a2-gift-inventory/a2-gift-inventory.component";
import { A2ProductInventoryComponent } from "./a2-product-inventory/a2-product-inventory.component";
import { A2ScanCodeSalesComponent } from "./a2-scan-code-sales/a2-scan-code-sales.component";
import { A2NaturalDistributionComponent } from "./a2-natural-distribution/a2-natural-distribution.component";
import { A2GeneralListComponent } from "./a2-general-list/a2-general-list.component";
import { A2ProductDistributionComponent } from "./a2-product-distribution/a2-product-distribution.component";
import { QcCustomerDetailComponent } from '../qc/qc-customer-detail/qc-customer-detail.component';
import { A2SampleGiftSelectionComponent } from './a2-sample-gift-selection/a2-sample-gift-selection.component';
import { ApprovalSelectionManagementComponent } from '../grid-calendar/approval-selection-management/approval-selection-management.component';
import { ScanningHomingComponent } from './scanning-homing/scanning-homing.component';
import { A2OrderWithoutcodeComponent } from './a2-order-withoutcode/a2-order-withoutcode.component';
import { ViplistComponent } from '../qc/viplist/viplist.component';
import { BaseCase } from "src/app/basecase";
import { CommonService } from "src/service/common.service";
@Component({
  selector: 'app-a2',
  templateUrl: './a2.component.html',
  styleUrls: ['./a2.component.scss']
})
export class A2Component extends GridBaseCase {

  @ViewChild("reminderDetail") reminderDetail: A2ReminderDetailComponent;
  @ViewChild("GiftInventory") GiftInventory: A2GiftInventoryComponent;
  @ViewChild("ProductInventory") ProductInventory: A2ProductInventoryComponent;
  @ViewChild("ScanCodeSales") ScanCodeSales: A2ScanCodeSalesComponent;
  @ViewChild("NaturalDistribution") NaturalDistribution: A2NaturalDistributionComponent;
  @ViewChild("GeneralList") GeneralList: A2GeneralListComponent;
  @ViewChild("ProductDistribution") ProductDistribution: A2ProductDistributionComponent;
  @ViewChild("customer") customer: QcCustomerDetailComponent;
  @ViewChild("SampleGiftSelection") SampleGiftSelection: A2SampleGiftSelectionComponent;
  @ViewChild("ScanningHoming") ScanningHoming: ScanningHomingComponent;
  @ViewChild("A2orderWithoutCode") A2orderWithoutCode: A2OrderWithoutcodeComponent;
  // 会员列表底部按钮
  @ViewChild("Viplist") Viplist: ViplistComponent;
  // 批量排班
  @ViewChild("ApprovalSelection")  ApprovalSelection: ApprovalSelectionManagementComponent;
  constructor(
    public baseService: BaseCase,
    public com: CommonService
  ) { super(); }

  ngOnInit() {
    // debugger;
    console.log(this.template,"日志");
  }
  A2submit(param, type: any = 0) {
    let that = this;
    switch (param) {
      case 'GiftInventory':
        this.GiftInventory.EventSubmitClick();
        break;
      case "ProductInventory":
        this.ProductInventory.EventSubmitClick();
        break;
      case "reminderDetail"://添加沟通记录
        if (that.baseService.FixedSubmitBtn["url"]) {
          that.com.setHistoryUrl(false);
          that.com.Go(that.baseService.FixedSubmitBtn["url"]);
        }
        // that.reminderDetail.EventSubmitClick();
        break;
      case "ScanCodeSales":
        that.ScanCodeSales.EventClick();
        break;
      case "NaturalDistribution":
        that.NaturalDistribution.EventClick();
        break;
      case "GeneralList":
        that.GeneralList.EventSubmit(type);
        break;
      case "ProductDistribution":
        if(type){
          that.ProductDistribution.EventClick();
        }else{
          that.ProductDistribution.EventCheckAllToggle();
        }
        break;
      case "customer":
        that.customer.EventSubmitClick();
        break;
      case "SampleGiftSelection":
        that.SampleGiftSelection.EventClick();
        break;
      case "ScanningHoming"://扫码归巢
        that.ScanningHoming.EventClick();
        break;
      case "Viplist"://扫码归巢
        if (type) {
          that.Viplist.EventClickCehcked();
        } else {
          that.Viplist.EventSure();
        }
        break;
        case "ApprovalSelection"://批量驳回/批量审批
        if (type) {
          that.ApprovalSelection.EventClickCehckedpro();
        } else {
          that.ApprovalSelection.EventSurepro();
        }
        break;
        case "A2orderWithoutCode"://无码退货
        that.A2orderWithoutCode.EventClick();
        break;

      // case 'TransitionDetail':
      // case 'RepurchaseDetail':
      // case 'AwakenDetail' :
      // case 'BirthdayDetail':
      // case 'NewcustomersDetail':
      //     this.ReminderDetail.EventSubmitClick();
    }
  }
}
